const messages = {
  _default:     (field) => `O valor do campo ${field} não é válido.`,
  alpha:        (field) => `O campo ${field} pode conter apenas letras.`,
  alpha_dash:   (field) => `O campo ${field} pode conter caracteres alfanuméricos, hífens e underlines.`,
  alpha_num:    (field) => `O campo ${field} pode conter apenas caracteres alfanuméricos.`,
  alpha_spaces: (field) => `O campo ${field} pode conter apenas letras e espaços.`,
  confirmed:    (field) => `O valor do campo de confirmação ${field} não combina.`,
  credit_card:  (field) => `O campo ${field} não é válido.`,
  email:        (field) => `O campo ${field} deve ser um email válido.`,
  excluded:     (field) => `O campo ${field} deve ser um valor válido.`,
  ext:          (field) => `O campo ${field} deve ser um arquivo válido.`,
  image:        (field) => `O campo ${field} deve ser uma imagem.`,
  included:     (field) => `O campo ${field} deve ser um valor válido.`,
  integer:      (field) => `O campo ${field} deve ser um número inteiro.`,
  ip:           (field) => `O campo ${field} deve ser um endereço ip válido.`,
  ip_or_fqdn:   (field) => `O campo ${field} deve ser um endereço ip ou FQDN válido.`,
  mimes:        (field) => `O campo ${field} deve ser de um tipo válido.`,
  numeric:      (field) => `O campo ${field} pode conter apenas números.`,
  regex:        (field) => `O campo ${field} não é válido.`,
  required:     (field) => `O campo ${field} é obrigatório.`,
  url:          (field) => `O campo ${field} não é um endereço válido.`,
  min_value:    (field, [min]) => `O valor mínimo do campo ${field} deve ser ${min}.`,
  max_value:    (field, [max]) => `O valor máximo do campo ${field} deve ser ${max}.`,
  size:         (field, [size]) => `O tamanho máximo do campo ${field} deve ser ${size}.`,
  date_format:  (field, [format]) => `O campo ${field} deve estar no formato ${format}.`,
  min:          (field, [length]) => `O campo ${field} deve ter pelo menos ${length} caracteres.`,
  max:          (field, [length]) => `O campo ${field} deve ter no máximo ${length} caracteres.`,
  digits:       (field, [length]) => `O campo ${field} deve ser um número e conter exatamente ${length} dígitos.`,
  required_if:  (field, [target]) => `O campo ${field} é obrigatório quando o campo ${target} tem este valor.`,
  between:      (field, [min, max]) => `O campo ${field} deve estar entre ${min} e ${max}.`,
  date_between: (field, [min, max]) => `O campo ${field} deve estar entre ${min} e ${max}.`,
  dimensions:   (field, [width, height]) => `O campo ${field} deve conter uma imagem com ${width} pixels de largura e ${height} pixels de altura.`,
  after:        (field, [target, inclusion]) => `O campo ${field} deve conter uma data depois de ${inclusion ? 'ou igual a ' : ''}${target}.`,
  before:       (field, [target, inclusion]) => `O campo ${field} deve conter uma data antes de ${inclusion ? 'ou igual a ' : ''}${target}.`,
  decimal:      (field, [decimals = '*'] = []) => `O campo ${field} deve ser um número e pode conter${!decimals || decimals === '*' ? '' : decimals} pontos decimais.`,
  length:       (field, [length, max]) => {
    if (max) {
      return `O tamanho do campo ${field} deve estar entre ${length} e ${max}.`
    }

    return `O tamanho do campo ${field} deve ser ${length}.`
  }
}

const locale = {
  name: 'br',
  messages,
  attributes: {}
}

export default locale
